module.exports = __webpack_public_path__ + "img/vaccine.658dbfb8.png";